import { render, staticRenderFns } from "./CourseContents.vue?vue&type=template&id=14662431&scoped=true"
import script from "./CourseContents.vue?vue&type=script&lang=js"
export * from "./CourseContents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14662431",
  null
  
)

export default component.exports